module.exports = __webpack_public_path__ + "static/019-476a6759a22031cbfdcaf7dbfaaa3d0d.jpg";